import moment from 'moment'
import store from '@/store'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { authHeader } from '@/services/auth'
import { $t } from '@/i18n'

function addProduits (produits) {
  store.commit('setProduits', produits)
}

function removeProduits () {
  store.commit('setProduits', null)
}
function removePopupProduitSfc () {
  store.commit('setPopupSfcVue', false)
}

export async function getUsers (filters) {
  const user = store.getters.getAdvertiser
  if (user && typeof user === 'object' && user.advertiser !== undefined) {
    filters.advertiser = user.advertiser
  }
  const qs = require('qs')
  const params = {
    headers: authHeader('application/ld+json'),
    params: filters,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false })
    }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/users', params)
    .then(response => {
      return {
        total: response.data['hydra:totalItems'],
        list: response.data['hydra:member']
      }
    })
    .catch(error => {
      // this.errored = true
      return { type: 'error', message: error }
    })
}

export async function exportUsers (ids) {
  const qs = require('qs')
  const params = {
    roleLabel: {
      mainAccount: $t('users.mainAccount'),
      ROLE_SUB_ADMIN: $t('users.admin'),
      ROLE_SUB_USER: $t('users.user'),
      ROLE_CONTACT: $t('users.contact')
    }
  }
  if (ids && ids.length) {
    params.id = ids
  }
  const config = {
    responseType: 'blob',
    params: params,
    paramsSerializer: function (serializedParams) {
      return qs.stringify(serializedParams, { encodeValuesOnly: true })
    }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/annonceurs/users/export', config)
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([response.data]))
      link.setAttribute('download', 'export_utilisateurs_' + moment().format('DD_MM_YYYY_HH_mm_ss') + '.csv')
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function importUsers (file) {
  const formData = new FormData()
  formData.append('file', file)

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/annonceurs/users/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => response.data)
    .catch(error => {
      const data = error && error.response && error.response.data
      if (data && data.rejected) {
        return data
      }
      return { type: 'error', message: error }
    })
}

export async function createUser (user) {
  user.username = 'auto'
  user.mainAccount = false

  return HTTP_HYPER_ESPACE_BACKEND.post('/users', user)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function updateUser (user) {
  const { id, ...data } = user
  return HTTP_HYPER_ESPACE_BACKEND.patch('/users/' + id, data)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

// $stopPopupSfc
export async function putStopPopupSfc (user) {
  const params = {
    stopPopupSfc: true,
    splashScreenAlreadySeen: true
  }

  return HTTP_HYPER_ESPACE_BACKEND.patch('/users/' + user.id, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

// $stopPopupSfc
export async function putStopPopupBiensVendus (user) {
  const params = {
    stopPopupBiensVendus: true
  }

  return HTTP_HYPER_ESPACE_BACKEND.patch('/users/' + user.id, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function getUrlSFC (user) {
  const params = {
    login: 'ag' + user.advertiser
  }

  return HTTP_HYPER_ESPACE_BACKEND.post('/sfc/autolink', params)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function checkResetPasswordStatusSFC (filters) {
  const params = filters

  return HTTP_HYPER_ESPACE_BACKEND.post('/sfc/check_reset_password_status', params)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function deleteUserContact (userId) {
  return HTTP_HYPER_ESPACE_BACKEND.delete('/users/' + userId)
}

export async function portailClientConnect () {
  const params = {}
  return HTTP_HYPER_ESPACE_BACKEND
    .get('/portail-client-connect', params)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}
